import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/help">Help</Link>
        <a href="mailto:doccy@prutkowski.dev">Contact</a>
      </div>
      <p className="footer-copy">&copy; {new Date().getFullYear()} Doccy. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
